import FeatureFlags from "../../features/feature-flags/FeatureFlags";

export default function FeatureFlagsPage() {
  return (
    <div>
      <FeatureFlags />
    </div>
  );
}
